import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    flex: {
      display: "flex",
      marginTop: "16px",
      marginBottom: " 32px",
      background: theme.palette.common.white
    },
    actionButton: {
      width: "132px",
      fontSize: "14px",
      height: "40px"
    },
    disableBtn: {
      "& svg path": {
        stroke: "#CCCCCC"
      }
    }
  }),
  { name: "SearchPMTForm" }
);

export default useStyles;
